export enum SECTION_NAMES {
  // new
  VIDEO_TEXT = 'video-text',
  IMAGE_ACCORDIONS = 'image-accordions',
  CARDS_WITH_HEADER = 'cards-with-header',
  CODE_BLOCK = 'code-block',
  TEXT_BLOCK = 'text-block',
  CTA_BLOCK = 'cta-block',
  TEXT_IMAGE = 'text-image',
  SOCIAL_PROOF = 'social-proof',
  HERO_WITH_SEARCH = 'hero-with-search',
  OPEN_POSITIONS_LIST = 'open-positions-list',
  JOB_APPLICATION_FORM = 'job-application-form',
  LOGO_CAROUSEL = 'logo-carousel',
  RECOMMENDATION_CARDS = 'recommendation-cards',
  SCRAPER_PLAYGROUND = 'scraper',
  WHAT_IS_MY_IP = 'what-is-my-ip',
  IMAGE_BLOCK = 'image-block',
  CAROUSEL_BLOCK = 'carousel-block',
  ARTICLES_FEED = 'articles-feed',
  AUTHOR = 'author',
  RELATED_ARTICLES = 'related-articles',
  TEXT_GRID = 'text-grid',
  PRODUCT_CARDS = 'product-cards',
  BLOG_OVERVIEW = 'blog-overview',
  TABLE = 'table',
  FEATURES_BLOCK = 'features-block',
  SCRAPING_TEMPLATE_LIBRARY = 'scraping-template-library',
  SCRAPING_TEMPLATE_PREVIEW = 'scraping-template-preview',
  CONTACT_SALES = 'contact-sales',
  QUOTE = 'quote',
  BANNER = 'banner',
  COMPARISON_TABLE = 'comparison-table',

  // old but still used
  HERO = 'hero',
  PRICING_CARDS = 'pricing-cards',
  PRICING_TABLE = 'pricing-table',
  FAQ = 'faq',
  SIMPLE_CARDS = 'simple-cards',
  FOOTER = 'footer',
  VIDEO_BLOCK = 'video-block',
  HERO_FEATURES = 'hero-3-usp-columns-homepage',

  // old
  LOCATION_FLAGS = 'location-flags',
  USE_CASES = 'use-cases',
  TRUSTPILOT_REVIEWS = 'trustpilot-reviews',
  TEXT_IMAGE_COLUMNS = 'text-image-columns',
  TEXT_IMAGE_CTA = 'text-image-cta',
  IMAGE_TEXT_COLUMN = 'image-text-column',
  PRICING_SLIDER = 'pricing-slider',
  BADGES = 'badges',
  PAYMENT_METHOD = 'payment-method',

  HERO_LOGOS = 'hero-recognized-by-homepage',
  WEBINAR_REGISTRATION_FORM = 'webinar-registration-form',
  BIGGER_PLANS = 'bigger-plans-banner',
}
